import React from 'react';
import tinycolor from 'tinycolor2';

const MinimalistCrab = (props) => {
  const { radius, cells } = props;
  const base = cells[1].background;

  return (
    
    <svg width={`${radius * 3}px`} height={`${radius * 2}px`} x={`-${radius * 1.5}px`} y={`-${radius * 1.7}px`} viewBox="0 0 300 200" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
        <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g id="Artboard-2">
            <g id="Group-3">
              <path d="M50,0 L50,50 L0,50 C0,22.3857625 22.3857625,0 50,0 Z M100,50 C100,77.6142375 77.6142375,100 50,100 C22.3857625,100 0,77.6142375 0,50 L100,50 Z" id="Combined-Shape" fill={base}></path>
              <path d="M250,0 C277.614237,0 300,22.3857625 300,50 L250,50 L250,0 Z M300,50 C300,77.6142375 277.614237,100 250,100 C222.385763,100 200,77.6142375 200,50 L300,50 Z" id="Combined-Shape" fill={base}></path>
              <path d="M50,170 C50,114.771525 94.771525,70 150,70 C205.228475,70 250,114.771525 250,170 L50,170 Z" id="Oval-3" fill={base}></path>
              <g id="Group" transform="translate(124.000000, 47.000000)" fill="#363636">
                  <circle id="Oval" cx="7.5" cy="7.5" r="7.5"></circle>
                  <circle id="Oval-Copy" cx="44.5" cy="7.5" r="7.5"></circle>
              </g>
              <path d="M59,175 C45.1928813,175 34,186.192881 34,200 L59,200 L59,175 Z" id="Oval-2" fill={base}></path>
              <path d="M171,175 C184.807119,175 196,186.192881 196,200 L171,200 L171,175 Z" id="Oval-2-Copy-3" fill={base}></path>
              <path d="M94,175 C80.1928813,175 69,186.192881 69,200 L94,200 L94,175 Z" id="Oval-2-Copy" fill={base}></path>
              <path d="M206,175 C219.807119,175 231,186.192881 231,200 L206,200 L206,175 Z" id="Oval-2-Copy-4" fill={base}></path>
              <path d="M129,175 C115.192881,175 104,186.192881 104,200 L129,200 L129,175 Z" id="Oval-2-Copy-2" fill={base}></path>
              <path d="M241,175 C254.807119,175 266,186.192881 266,200 L241,200 L241,175 Z" id="Oval-2-Copy-5" fill={base}></path>
            </g>
          </g>
        </g>
    </svg>
  )
}
export default MinimalistCrab;

export function resize(props) {
  const {radius, minY, maxY, minX, maxX} = props;

  return {
    ...props,
    minY: minY + radius * 0.7,
    maxY: maxY + radius * 0.3,
    minX: minX + radius * 0.5,
    maxX: maxX + radius * 0.5,
  };
}


// WEBPACK FOOTER //
// ./src/core/thematic/minimalist/crab.js